import {NgModule} from '@angular/core';

import {MzTooltipDirective} from './tooltip.directive';

@NgModule({
  declarations: [MzTooltipDirective],
  exports: [MzTooltipDirective],
})
export class MzTooltipModule {
}
